"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Player = function Player(props) {
  var content = props.settings.content;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].block
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: content
  }));
};
Player.propTypes = {
  settings: _propTypes["default"].object,
  template: _propTypes["default"].func,
  templateExtraProps: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  children: _propTypes["default"].array,
  goToComponent: _propTypes["default"].func,
  playerTemplateProps: _propTypes["default"].object,
  accommodations: _propTypes["default"].object
};
var _default = (0, _cccisdSurveyCommon.playerWrapper)({})(Player);
exports["default"] = _default;